export default __webpack_public_path__ + "high_m766519.png";